import { sync, cancelSync } from '../../frameloop/index.mjs';
var frameloopDriver = function frameloopDriver(update) {
  var passTimestamp = function passTimestamp(_ref) {
    var timestamp = _ref.timestamp;
    return update(timestamp);
  };
  return {
    start: function start() {
      return sync.update(passTimestamp, true);
    },
    stop: function stop() {
      return cancelSync.update(passTimestamp);
    },
    now: function now() {
      return performance.now();
    }
  };
};
export { frameloopDriver };